var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlackIntegration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 84,
    viewBox: "0 0 100 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_905_26)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.748047 81.3554L2.56335 77.1698C4.52504 78.6231 7.13087 79.3789 9.70742 79.3789C11.6106 79.3789 12.811 78.6523 12.811 77.5477C12.7817 74.4666 1.42146 76.8792 1.33363 69.1477C1.30435 65.2237 4.81783 62.2009 9.79526 62.2009C12.7524 62.2009 15.7096 62.9275 17.8177 64.5843L16.1196 68.857C14.1872 67.6362 11.7862 66.7642 9.50247 66.7642C7.95068 66.7642 6.92592 67.4908 6.92592 68.4209C6.95519 71.4438 18.4033 69.7871 18.5204 77.1698C18.5204 81.1809 15.0947 84.0004 10.1759 84.0004C6.57456 84.0004 3.26604 83.1575 0.748047 81.3554Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4034 75.6584C69.4957 77.228 67.7975 78.3034 65.8358 78.3034C62.9372 78.3034 60.5949 75.9781 60.5949 73.1006C60.5949 70.2231 62.9372 67.8977 65.8358 67.8977C67.7975 67.8977 69.4957 68.9732 70.4034 70.5428L75.41 67.7815C73.5362 64.468 69.9349 62.2009 65.8358 62.2009C59.775 62.2009 54.8562 67.0839 54.8562 73.1006C54.8562 79.1173 59.775 84.0004 65.8358 84.0004C69.9641 84.0004 73.5362 81.7623 75.41 78.4197L70.4034 75.6584Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3047 53.1612H21.0389V83.5934H27.3047V53.1612Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.8687 53.1612V83.5934H84.1344V74.4666L91.5713 83.5934H99.5938L90.1366 72.7518L98.8911 62.6368H91.2199L84.1344 71.0369V53.1612H77.8687Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9251 75.7166C45.0174 77.1989 43.1435 78.3034 41.0354 78.3034C38.1369 78.3034 35.7945 75.9781 35.7945 73.1006C35.7945 70.2231 38.1369 67.8977 41.0354 67.8977C43.1435 67.8977 45.0174 69.0604 45.9251 70.5718V75.7166ZM45.9251 62.6368V65.1074C44.9003 63.3925 42.353 62.2009 39.6887 62.2009C34.1842 62.2009 29.8508 67.0258 29.8508 73.0715C29.8508 79.1173 34.1842 84.0004 39.6887 84.0004C42.353 84.0004 44.9003 82.8086 45.9251 81.0937V83.5644H52.1907V62.6368H45.9251Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1137 27.8408C37.1137 30.4005 35.0297 32.4692 32.4512 32.4692C29.8729 32.4692 27.7889 30.4005 27.7889 27.8408C27.7889 25.2811 29.8729 23.2124 32.4512 23.2124H37.1137V27.8408Z",
    fill: "#E01E5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4457 27.8408C39.4457 25.2811 41.5295 23.2124 44.108 23.2124C46.6865 23.2124 48.7703 25.2811 48.7703 27.8408V39.4118C48.7703 41.9715 46.6865 44.0403 44.108 44.0403C41.5295 44.0403 39.4457 41.9715 39.4457 39.4118V27.8408Z",
    fill: "#E01E5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1079 9.25685C41.5294 9.25685 39.4456 7.18808 39.4456 4.62843C39.4456 2.06877 41.5294 0 44.1079 0C46.6862 0 48.7702 2.06877 48.7702 4.62843V9.25685H44.1079Z",
    fill: "#36C5F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1086 11.6062C46.6869 11.6062 48.7709 13.675 48.7709 16.2347C48.7709 18.7943 46.6869 20.8631 44.1086 20.8631H32.4174C29.839 20.8631 27.755 18.7943 27.755 16.2347C27.755 13.675 29.839 11.6062 32.4174 11.6062H44.1086Z",
    fill: "#36C5F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7925 16.2347C62.7925 13.675 64.8765 11.6062 67.4549 11.6062C70.0332 11.6062 72.1172 13.675 72.1172 16.2347C72.1172 18.7943 70.0332 20.8631 67.4549 20.8631H62.7925V16.2347Z",
    fill: "#2EB67D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4624 16.2345C60.4624 18.7942 58.3786 20.8629 55.8001 20.8629C53.2217 20.8629 51.1378 18.7942 51.1378 16.2345V4.62843C51.1378 2.06877 53.2217 0 55.8001 0C58.3786 0 60.4624 2.06877 60.4624 4.62843V16.2345Z",
    fill: "#2EB67D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7977 34.7838C58.376 34.7838 60.46 36.8524 60.46 39.4122C60.46 41.9719 58.376 44.0406 55.7977 44.0406C53.2192 44.0406 51.1354 41.9719 51.1354 39.4122V34.7838H55.7977Z",
    fill: "#ECB22E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8 32.4692C53.2215 32.4692 51.1376 30.4005 51.1376 27.8408C51.1376 25.2811 53.2215 23.2124 55.8 23.2124H67.491C70.0695 23.2124 72.1535 25.2811 72.1535 27.8408C72.1535 30.4005 70.0695 32.4692 67.491 32.4692H55.8Z",
    fill: "#ECB22E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_905_26"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 84,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlackIntegration);
export default __webpack_public_path__ + "static/media/SlackIntegration.c31102ccb936c946745ff1010c8c8be8.svg";
export { ForwardRef as ReactComponent };